import Script from 'next/script'

import { initScript as bingInitScript } from '@repo/analytics/bing'

import {
  initScript as facebookPixelInitScript,
  FacebookPixel as FacebookPixelImage,
} from '@repo/analytics/facebook'
import { GlobalSiteTag } from './global-site-tag'
import { GlobalOneTapLogin } from './global-one-tap-login'
import { Clarity } from './clarity'
import { IubendaScripts, useIubendaConfig } from './iubenda'

const Bing = () => {
  const { scriptProps, variant } = useIubendaConfig()

  if (variant === 'locationNotSet') {
    return null
  }

  return (
    <Script id="bing-script" strategy="afterInteractive" {...scriptProps}>
      {bingInitScript}
    </Script>
  )
}

const FacebookPixel = () => {
  const { scriptProps, variant } = useIubendaConfig()

  if (variant === 'locationNotSet') {
    return null
  }

  return (
    <>
      <Script id="facebook-pixel-script" strategy="afterInteractive" {...scriptProps}>
        {facebookPixelInitScript}
      </Script>
      <FacebookPixelImage />
    </>
  )
}

interface AnalyticsProps {
  userId?: string
  autoLogin?: boolean
}

export const Analytics = ({ userId, autoLogin }: AnalyticsProps = {}) => {
  return (
    <>
      <GlobalOneTapLogin autoSelect={autoLogin} />
      <GlobalSiteTag />
      <FacebookPixel />
      <Bing />
      <Clarity userId={userId} />
      <IubendaScripts />
    </>
  )
}
